import { render } from "./HeroiconsSolidScale.vue?vue&type=template&id=4a717a33"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidScale.vue"]])

export default __exports__